import {
    faGear as duoToneFaGear,
    faBadgeDollar as duoToneFaBadgeDollar,
    faChartSimple as duoToneFaChartSimple,
    faMessageExclamation as duoToneFaMessageExclamation,
} from "@fortawesome/pro-duotone-svg-icons"
import {rolesPermissions} from "./permissions"
import {
    faBadgeDollar,
    faChartSimple,
    faClock,
    faMessageExclamation,
    faGear,
    faBuilding,
    faChartNetwork,
    faLocationDot,
    faBook,
    faMoneyCheckDollar,
} from "@fortawesome/pro-light-svg-icons"
import {
    faBuilding as duoToneFaBuilding,
    faLocationDot as duoToneFaLocationDot,
    faChartNetwork as douToneFaChartNetwork,
    faClock as duoToneFaClock,
    faBook as duoToneFaBook,
    faMoneyCheckDollar as duoToneFaMoneyCheckDollar,
} from "@fortawesome/pro-duotone-svg-icons"

export const MenuList: any = [
    {
        id: "company-module",
        icon: faBuilding,
        selected_icon: duoToneFaBuilding,
        name: "Company Management",
        path: "/company-management",
        child: [
            {
                id: "company-profile",
                icon: "",
                selected_icon: "",
                name: "Profile",
                path: "/company-management/profile",
            },
            {
                id: "registration",
                icon: "",
                selected_icon: "",
                name: "Companies",
                path: "/company-management/registration",
                submenu_path: "/company-management/registration/details",
            },
            {
                id: "mapping",
                icon: "",
                selected_icon: "",
                name: "Mapping",
                path: "/company-management/mapping",
            },
            {
                id: "admin",
                icon: "",
                selected_icon: "",
                name: "Admin",
                path: "/company-management/admin",
            },
        ],
    },
    {
        id: "settlement",
        icon: faMoneyCheckDollar,
        selected_icon: duoToneFaMoneyCheckDollar,
        name: "Settlements",
        path: "/settlement",
        child: [
            {
                id: "payout-info",
                icon: "",
                selected_icon: "",
                name: "Payout Info",
                path: "/settlement/payout-info",
            },
            {
                id: "abnormal-transaction",
                icon: "",
                selected_icon: "",
                name: "Abnormal Transaction",
                path: "/settlement/abnormal-transaction",
            },
            {
                id: "disputed-transaction",
                icon: "",
                selected_icon: "",
                name: "Dispute Transaction",
                path: "/settlement/dispute-transaction",
            },
        ],
    },
    {
        id: "location-module",
        icon: faLocationDot,
        selected_icon: duoToneFaLocationDot,
        name: "Locations",
        path: "/locations",
        child: [
            {
                id: "station",
                icon: "",
                selected_icon: "",
                name: "Stations",
                path: "/locations/stations",
            },
            {
                id: "charger",
                icon: "",
                selected_icon: "",
                name: "Chargers",
                path: "/locations/chargers",
                submenu_path: "/locations/chargers/charger-profile",
            },
        ],
    },
    {
        id: "network-module",
        icon: faChartNetwork,
        selected_icon: douToneFaChartNetwork,
        name: "Network",
        path: "/network",
    },
    {
        id: "tariff-module",
        icon: faChartSimple,
        selected_icon: duoToneFaChartSimple,
        name: "Tariff",
        path: "/tariff",
    },
    {
        id: "token-module",
        icon: faBadgeDollar,
        selected_icon: duoToneFaBadgeDollar,
        name: "Tokens",
        path: "/tokens",
    },
    {
        id: "session-module",
        icon: faClock,
        selected_icon: duoToneFaClock,
        name: "Sessions",
        path: "/sessions",
        child: [
            {
                id: "session-module",
                icon: "",
                selected_icon: "",
                name: "Session Details",
                path: "/sessions/session-details",
            },
            {
                id: "session-module",
                icon: "",
                selected_icon: "",
                name: "Session Flow Timeline",
                path: "/sessions/session-timeline",
            },
        ],
    },
    {
        id: "log-module",
        icon: faBook,
        selected_icon: duoToneFaBook,
        name: "Logs",
        path: "/logs",
    },
    {
        id: "complaint-module",
        icon: faMessageExclamation,
        selected_icon: duoToneFaMessageExclamation,
        name: "Complaints",
        path: "/complaints",
    },
    {
        id: "configuration",
        icon: faGear,
        selected_icon: duoToneFaGear,
        name: "Configurations",
        path: "/configurations",
    },
]

export const handleMenuList = (menu: any, userPermissions: any) => {
    const allPermissions = rolesPermissions
    const currentPermissions =
        userPermissions.length > 0 ? userPermissions.filter((item: any) => allPermissions.includes(item)) : {}
    const currentMenuPermissions = menu.reduce((acc: any, item: any) => {
        if (currentPermissions.length > 0 && currentPermissions.includes(item.id)) {
            const filteredItem = {...item}
            if (item.child) {
                filteredItem.child = handleMenuList(item.child, userPermissions)
                if (filteredItem.child.length === 0) {
                    delete filteredItem.child
                }
            }
            acc.push(filteredItem)
        }
        return acc
    }, [])

    return currentMenuPermissions
}
